import { helpers } from 'vuelidate/lib/validators';
export const chass = helpers.regex('chass', /^[A-Za-z]{4}\d{6}$/);
export const count = helpers.regex('count', /^[A-Za-z]{4}\d{7}$/);
export const email = helpers.regex(
    'email',
    /^[-\w+.%]+@[\w-.]+\.[A-Za-z]{2,12}(?:,[-\w+.%]+@[\w-.]+\.[A-Za-z]{2,12}){0,25}$/
);